import script from "./ConfettiAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfettiAnimation.vue?vue&type=script&setup=true&lang=js"

import "./ConfettiAnimation.vue?vue&type=style&index=0&id=0f224381&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f224381"]])

export default __exports__